module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hans_1-60ee080e68a5d5b24f710261aedc6dec.jpg";